import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import '@progress/kendo-theme-default/dist/all.css';
import { BrowserRouter as Router } from 'react-router-dom';

// ResizeObserver-based components (e.g. the PDF viewer) can fire the benign
// "ResizeObserver loop ..." browser notice when a resize callback triggers
// another layout in the same frame. It breaks nothing and never surfaces in
// production, but CRA's dev error overlay pops on it. Deferring the callback to
// the next frame breaks the synchronous loop so the notice is never emitted.
const NativeResizeObserver = window.ResizeObserver;
if (NativeResizeObserver) {
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) =>
        window.requestAnimationFrame(() => callback(entries, observer))
      );
    }
  };
}

let root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

//@ts-ignore
root.render(
  //Strict Mode needs to be removed due to Telerikk Report Viewer https://docs.telerik.com/reporting/knowledge-base/react-viewer-does-not-load-dispose-error?_ga=2.13009015.1924139473.1674431428-945463639.1657681083&_gl=1*flnx6e*_ga*OTQ1NDYzNjM5LjE2NTc2ODEwODM.*_ga_9JSNBCSF54*MTY3NDYwNDEzMy4xNjEuMS4xNjc0NjA0Mzk1LjU0LjAuMA..
  
  // <React.StrictMode>
    <Router>
      <App />
    </Router>
  // </React.StrictMode>,
);